import { Admin, Token, ILogin } from '@/domain/entities/Admin'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class AuthDataMapper extends BaseResponseMapper {
  public convertAuthFromApi(result: AxiosResponse<ILogin>) {
    const { data } = result

    return new Admin(
      data.id,
      data.name,
      data.email,
      data.phone,
      '',
      data.profile,
      0,
      data.menu,
      new Token(data.token, data.expires_at)
    )
  }
}
